import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { categoriesStore } from "../../../../stores/useCategoriesStore";
import { GalleryCarousel } from "./GalleryCarousel";
import { Loader } from "../../../loaders/Loader";
import { seconds } from '@yehonadav/timeunit';
import { galleriesStore } from "../../../../stores/galleries/galleriesStore";
import { WwwGalleryCard } from "../../galleries/gallery/WwwGalleryCard";
import { galleryCategoryAssociationsStore } from "../../../../stores/galleries/galleryCategoryAssociationsStore";
import { RequestStatus } from "common-frontend-components";
import { Box, Grid } from "@mui/material";
export const PhotoGalleryCategories = ({ gallery }) => {
    const categoriesStatus = categoriesStore.useRequestStatus();
    const galleryCategoryAssociationsStatus = galleryCategoryAssociationsStore.useRequestStatus();
    const categories = useMemo(() => galleryCategoryAssociationsStore.getGalleryCategories(gallery.id), [gallery.id, galleryCategoryAssociationsStatus]);
    if (categories.length === 0 && categoriesStatus === RequestStatus.loaded)
        return _jsx(_Fragment, {}, void 0);
    return (_jsx(_Fragment, { children: categories.map((category, index) => _jsx(GalleryCarousel, { delay: index * seconds / 3, category: category, itemsLimit: 12 }, category.id)) }, void 0));
};
export const PhotoGallery = ({ gallery }) => {
    const request = categoriesStore.useRequestStatus();
    const categories = useMemo(() => galleryCategoryAssociationsStore.getGalleryCategories(gallery.id), [gallery.id]);
    if (categories.length === 0 && request === RequestStatus.loaded)
        return _jsx(_Fragment, {}, void 0);
    return (_jsxs(_Fragment, { children: [_jsx(Box, { sx: { paddingTop: 4 } }, void 0), _jsx(Grid, { container: true, justifyContent: 'center', children: _jsx(WwwGalleryCard, { gallery: gallery }, void 0) }, void 0), _jsx(PhotoGalleryCategories, { gallery: gallery }, void 0), _jsx(Box, { sx: { paddingTop: 4 } }, void 0)] }, void 0));
};
export const PhotoGalleries = () => {
    const galleries = galleriesStore.useGalleries();
    const request = galleriesStore.useRequestStatus();
    return (_jsx(Loader, { status: request, data: galleries, children: galleries.map((gallery) => _jsx(PhotoGallery, { gallery: gallery }, gallery.id)) }, void 0));
};
//# sourceMappingURL=PhotoGallery.js.map